// extracted by mini-css-extract-plugin
module.exports = {"article":"article_article__1bqG5","hasStickyVideo":"article_hasStickyVideo__27ywk"};